import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    uuid: ""
}

const couponSlice = createSlice({
    name: "coupons",
    initialState,
    reducers: {
        setUUID(state, action) {
            state.uuid = action?.payload
        },
    }
})

export const { setDescription } = couponSlice.actions
export const couponActions = couponSlice.actions;

export default couponSlice;